import { BarChart3 } from 'lucide-react';
import { dashboardData } from '../data/claimsData';

import KpiCards           from './analytics/KpiCards';
import ClaimsTrend        from './analytics/ClaimsTrend';
import StatusDistribution from './analytics/StatusDistribution';
import MakeAnalytics      from './analytics/MakeAnalytics';
import ModelDistribution  from './analytics/ModelDistribution';
import CameraRadar        from './analytics/CameraRadar';
import PartsChart         from './analytics/PartsChart';
import FailureAnalysis    from './analytics/FailureAnalysis';
import ImageAnalytics     from './analytics/ImageAnalytics';
import UserPerformance    from './analytics/UserPerformance';
import DataTable          from './analytics/DataTable';

export default function Analytics() {
  return (
    <div className="h-full overflow-y-auto bg-background-primary">
      {/* Page header */}
      <div className="bg-background-dark px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <BarChart3 className="h-5 w-5 text-primary-light" />
          <div>
            <h1 className="text-sm font-bold text-white uppercase tracking-wide">Claims Analytics</h1>
            <p className="text-xs text-text-secondary mt-0.5">
              {dashboardData.kpis.totalClaims.toLocaleString()} records · AI Camera Inspection · Apr 2022 – Jun 2026
            </p>
          </div>
        </div>
        <span className="text-xs font-semibold px-2.5 py-1 rounded-full" style={{ background: '#10b98120', color: '#10b981' }}>
          ● Live data
        </span>
      </div>

      {/* Content */}
      <div className="px-6 py-5 space-y-5 max-w-screen-2xl mx-auto">
        <KpiCards kpis={dashboardData.kpis} />

        <div className="grid grid-cols-1 xl:grid-cols-3 gap-5">
          <div className="xl:col-span-2">
            <ClaimsTrend data={dashboardData.monthlyTrend} />
          </div>
          <StatusDistribution data={dashboardData.statusDist} kpis={dashboardData.kpis} />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <MakeAnalytics     data={dashboardData.makeData} />
          <ModelDistribution data={dashboardData.modelData} />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          <CameraRadar     data={dashboardData.cameraData} />
          <PartsChart      data={dashboardData.partsData}    kpis={dashboardData.kpis} />
          <FailureAnalysis data={dashboardData.failMakeData} />
        </div>

        <ImageAnalytics data={dashboardData.imgTrend} />

        <UserPerformance data={dashboardData.userPerf} />

        <DataTable data={dashboardData.tableData} />
      </div>
    </div>
  );
}
